import SkapaSegmentedControl, {
  type SegmentedControlProps,
} from "@ingka/segmented-control";

export const SegmentedControl = (props: SegmentedControlProps) => {
  return <SkapaSegmentedControl prefix="saleslead__" {...props} />;
};
